// A Japanese paper balloon, in toy space with the floor at y=0. Paper is
// light, so air drag matters as much as gravity: a tap sends it floating up
// and it drifts down slowly. A tap pushes it up and away from the finger,
// dents the paper where it struck, and lets a little air out through the
// hole at the top. Blowing into the hole puffs it round again and pops most
// dents back out. Taps that keep it off the floor count as a streak.
export class PaperBalloon{
  constructor({radius,start,bounds}){this.radius=radius;this.start=[...start];this.bounds=bounds;this.reset();}
  reset(){this.held=false;this.p=[...this.start];this.v=[0,0,0];this.air=1;this.dents=[];this.streak=0;this.cheered=false;this.puff=0;this.landed=true;}
  // The current radius: a softer balloon is a little smaller.
  get size(){return this.radius*(.82+.18*this.air);}
  // A tap at a point (toy space). power scales the push: a balloon squeezed
  // and let go springs up harder, and loses more air through its hole.
  hit(point,power=1){
    const R=this.radius,d=[this.p[0]-point[0],0,this.p[2]-point[2]],l=Math.hypot(d[0],d[2]);
    const side=l>1e-6?[d[0]/l,0,d[2]/l]:[0,0,0],off=Math.min(1,l/R);
    this.v=[side[0]*R*2.4*off*power,R*(7.8-1.8*off)*power,side[2]*R*2.4*off*.5*power];
    this.air=Math.max(.6,this.air-.025*Math.max(1,power));
    const dir=[point[0]-this.p[0],point[1]-this.p[1],point[2]-this.p[2]],dl=Math.hypot(...dir)||1;
    this.dents.push({dir:dir.map(x=>x/dl),depth:this.size*.12});
    if(this.dents.length>12){const a=this.dents.shift(),b=this.dents[0];b.depth=Math.min(this.size*.2,b.depth+a.depth*.5);}
    const events=['hit'];
    if(!this.landed||this.p[1]>this.size+.02){this.streak++;}else this.streak=1;
    this.landed=false;
    if(this.streak>=10&&!this.cheered){this.cheered=true;events.push('cheer');}
    return events;
  }
  inflate(){this.puff=.6;}
  // A held balloon stays in the hand; it does not fall or count as landed.
  catch(){this.v=[0,0,0];this.held=true;}
  free(){this.held=false;}
  step(dt){
    const events=[],R=this.radius,g=7*R,drag=Math.exp(-1.4*dt);
    if(this.held){if(this.puff>0)this.puff=Math.max(0,this.puff-dt);return events;}
    if(this.puff>0){this.puff=Math.max(0,this.puff-dt);this.air=Math.min(1,this.air+dt*.8);for(const d of this.dents)d.depth*=Math.exp(-dt*4);}
    this.v[1]-=g*dt;for(let a=0;a<3;a++){this.v[a]*=drag;this.p[a]+=this.v[a]*dt;}
    const s=this.size,{min,max}=this.bounds;
    for(const a of [0,2]){if(this.p[a]<min[a]+s){this.p[a]=min[a]+s;this.v[a]=Math.abs(this.v[a])*.4;}if(this.p[a]>max[a]-s){this.p[a]=max[a]-s;this.v[a]=-Math.abs(this.v[a])*.4;}}
    if(this.p[1]>max[1]-s){this.p[1]=max[1]-s;this.v[1]=-Math.abs(this.v[1])*.3;}
    if(this.p[1]<=s){
      this.p[1]=s;
      if(this.v[1]<-R*.6){this.v[1]*=-.3;this.v[0]*=.7;this.v[2]*=.7;}
      else{this.v[1]=0;this.v[0]*=Math.exp(-6*dt);this.v[2]*=Math.exp(-6*dt);if(Math.hypot(this.v[0],this.v[2])<.005)this.v=[0,0,0];}
      if(!this.landed){this.landed=true;this.streak=0;this.cheered=false;events.push('land');}
    }
    return events;
  }
  get busy(){return this.held||this.puff>0||Math.hypot(...this.v)>1e-3||this.p[1]>this.size+1e-3;}
}
